<template>
    <div class="table">
        <div class="container">
            <div class="handle-box">
                <el-input v-model="searchCondition.select_roleName" placeholder="查询关键角色" class="handle-input mr10"></el-input>
                <el-select v-model="searchCondition.select_roleType" placeholder="类型筛选" class="handle-select mr10">
                    <el-option key="0" value="" label="空"></el-option>
                    <el-option v-for="roleType of roleTypes" :label="roleType.name" :value="roleType.value"></el-option>
                </el-select>
                <el-select v-model="searchCondition.select_moduleType" placeholder="模块筛选" class="handle-select mr10">
                    <el-option key="0" value="" label="空"></el-option>
                    <el-option v-for="module of modules" :label="module.name" :value="module.packagePath"></el-option>
                </el-select>
                <el-button type="primary" icon="search" @click="search">搜索</el-button>
                <el-button type="primary" icon="search" @click="handleCreate">新建</el-button>
                <el-button type="primary" icon="delete" class="handle-del mr10" @click="delAll">批量删除</el-button>
            </div>
            <el-table :data="pageinfo.list" border class="table" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center" prop="id"></el-table-column>
                <el-table-column prop="roleName" label="角色名称" sortable width="150">
                </el-table-column>
                <el-table-column prop="roleType" label="角色类型" sortable width="120" :formatter="roleTypeFormatter">
                </el-table-column>
                <el-table-column prop="subordinateModuleType" label="角色所属模块" width="200" :formatter="moduleTypeFormatter">
                </el-table-column>
                <el-table-column prop="detail" label="详细信息">
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-goods" @click="handlePR(scope.$index, scope.row)">分权</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background :page-size="searchCondition.page_size" @current-change="handleCurrentChange" layout="prev, pager, next" :total="pageinfo.total">
                </el-pagination>
            </div>
        </div>

        <!-- 新建弹出框 -->
        <el-dialog title="新建" :visible.sync="visible.createVisible" width="30%">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="角色名称">
                    <el-input type="text" v-model="form.roleName"></el-input>
                </el-form-item>
                <el-form-item label="角色类型">
                    <el-select v-model="form.roleType" placeholder="角色类型" class="handle-select ">
                        <el-option key="1" label="resource" value="r"></el-option>
                        <el-option key="2" label="permission" value="p"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属模块">
                    <el-select v-model="form.moduleType" placeholder="模块筛选" class="handle-select mr10">
                        <el-option v-for="module of modules" :label="module.name" :value="module.packagePath"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细信息">
                    <el-input type="textarea" v-model="form.detail"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible.createVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveCreate">确 定</el-button>
            </span>
        </el-dialog> 

        <!-- 分配资源弹出框 -->
        <el-dialog title="分配资源" :visible.sync="visible.resourceVisible" width="30%">
            <el-form label-width="100px">
                <el-tree
                  :data="resourceData"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="resourceTree"
                  highlight-current
                  :props="treeProps"
                  >
                </el-tree>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible.resourceVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveRoleResources">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 分配权限弹出框 -->
        <el-dialog title="分配权限" :visible.sync="visible.permissionVisible" width="50%">
            <el-form label-width="100px">
                <el-tree
                  :data="permissionData"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="permissionTree"
                  highlight-current
                  :props="permissionTreeProps"
                  >
                </el-tree>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible.permissionVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveRolePermission">确 定</el-button>
            </span>
        </el-dialog> 

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="visible.editVisible" width="30%">
            <el-form ref="edit" :model="form" label-width="100px">
                <el-form-item label="角色名称">
                    <el-input type="text" v-model="form.roleName"></el-input>
                </el-form-item>
                <el-form-item label="角色类型">
                    <el-select v-model="form.roleType" placeholder="角色类型" disabled class="handle-select mr10">
                        <el-option key="1" label="resource" value="r"></el-option>
                        <el-option key="2" label="permission" value="p"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属模块">
                    <el-select v-model="form.moduleType" disabled placeholder="模块筛选" class="handle-select mr10">
                        <el-option v-for="module of modules" :label="module.name" :value="module.packagePath"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细信息">
                    <el-input type="textarea" v-model="form.detail"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible.editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog> 

        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="visible.delVisible" width="300px" center>
            <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible.delVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteRow">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                pageinfo: [],
                searchCondition: {
                    cur_page: 1,
                    page_size: 8,
                    select_roleName: '',
                    select_roleType: '',
                    select_moduleType:'',
                },
                visible:{
                    createVisible: false,
                    resourceVisible: false,
                    editVisible: false,
                    delVisible: false,
                    permissionVisible:false,
                },
                form: {
                    id: '',
                    roleName: '',
                    roleType: '',
                    moduleType: '',
                    detail: ''
                },
                roleTypes:[
                    {
                        name:'资源类',
                        value:'r'
                    },
                    {
                        name:'权限类',
                        value:'p'
                    }
                ],
                modules: [],
                multipleSelection: [],
                resourceData:[],
                permissionData: [],
                treeProps:{
                    label:function(data,node){
                        return data.resource.resourceName;
                    },
                    children:"childList"
                },
                permissionTreeProps:{
                    label:function(data,node){
                        return data.permission.permissionName;
                    },
                    children:"children"
                },
                permissionShuttleBox:{
                    data:[],
                    value:[],    
                    //穿梭框筛选方法
                    filterMethod(query, item) {
                        return item.label.indexOf(query) > -1;
                    }                
                }
            }
        },
        created() {
            // this.initResources();
            // this.initPermissions();
            this.initPages();
            this.initModules();
        },
        methods: {
            // 分页导航
            handleCurrentChange(val) {
                this.searchCondition.cur_page = val;
                this.initPages();
            },
            // 获取 easy-mock 的模拟数据
            initPages() {
                this.$axios({
                    method:'get',
                    url:  '/api/role/getRoles',
                    withCredentials:true,
                    params: {
                        pageNo: this.searchCondition.cur_page,
                        pageSize: this.searchCondition.page_size,
                        selectRoleName: this.searchCondition.select_roleName,
                        selectRoleType: this.searchCondition.select_roleType,
                        selectSubordinateModuleType: this.searchCondition.select_moduleType
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code==1){
                        this.$message.success("数据获取成功");
                        this.pageinfo = response.data.data;
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取数据失败")
                    console.log(error)       //请求失败返回的数据
                })
            },
            search() {
                this.initPages();
            },
            roleTypeFormatter(row,column){
                var result;
                switch(row.permissionXResource){
                    case "r" : result = "资源类";break;
                    case "p" : result = "权限类";break;
                    default: result = "";
                }
                return result;
            },
            moduleTypeFormatter(row,column){
                var mArr = this.modules;
                for(var t of mArr){
                    if(row.subordinateModuleType == t.packagePath)
                        return t.name;
                }
            },
            handleCreate() {
                this.form = {};
                this.visible.createVisible = true
            },
            handlePR(index,row) {
                this.form.id = row.id;
                this.form.moduleType = row.subordinateModuleType;
                if("r"==row.permissionXResource){
                    this.initResources();
                    this.getCheckedResources();
                    this.visible.resourceVisible = true;
                }else if("p"==row.permissionXResource){
                    this.initPermissions();
                    this.getCheckedPermissions();
                    this.visible.permissionVisible = true;
                }else{
                    this.$message.error("角色属性错误")
                }
            },
            getCheckedPermissions(){
                this.$axios({
                    method:'get',
                    url: '/api/role/getRole',
                    withCredentials:true,
                    params:{roleId:this.form.id}
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        var tempSelectIdArr = [];
                        var tempSelectPermissionArr = response.data.data.permissions;
                        for(let item of tempSelectPermissionArr){
                            tempSelectIdArr.push(item.tAdnPermission.id);
                        }
                        this.$refs.permissionTree.setCheckedKeys(tempSelectIdArr);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取checkedPermission失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            initPermissions(){
                this.$axios({
                    method:'get',
                    url: '/api/permission/getPermissions',
                    withCredentials:true,
                    params:{
                        modulePackage:this.form.moduleType
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.permissionData = response.data.data;
                        this.permissionDataAddId(this.permissionData);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取permission失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            getCheckedResources(){
                this.$axios({
                    method:'get',
                    url: '/api/role/getRole',
                    withCredentials:true,
                    params:{roleId:this.form.id}
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        var tempSelectIdArr = [];
                        var tempSelectResourcesArr = response.data.data.resources
                        for(let i=0;i<tempSelectResourcesArr.length;i++){
                            tempSelectIdArr.push(tempSelectResourcesArr[i].tAdnResource.id);
                        }
                        this.$refs.resourceTree.setCheckedKeys(tempSelectIdArr);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取user失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            initResources(){
                this.$axios({
                    method:'get',
                    url: '/api/resource/getResources',
                    withCredentials:true,
                    params:{
                        modulePackage:this.form.moduleType
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.resourceData = response.data.data;
                        this.resourceDataAddId(this.resourceData);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取resources失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            resourceDataAddId(data){
                for(let i=0;i<data.length;i++){
                    data[i].id = data[i].resource.id;
                    if(data[i].childList == null){
                        continue;
                    }
                    this.resourceDataAddId(data[i].childList);
                }
            },
            permissionDataAddId(data){
                for(let i=0;i<data.length;i++){
                    data[i].id = data[i].permission.id;
                    if(data[i].children == null){
                        continue;
                    }
                    this.permissionDataAddId(data[i].children);
                }
            },
            handleEdit(index, row) {
                this.form.id = row.id;
                this.getRole();
                this.visible.editVisible = true;
            },
            getRole(){
                this.$axios({
                    method:'get',
                    url: '/api/role/getRole',
                    withCredentials:true,
                    params: {roleId: this.form.id}
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.form = {
                            id:this.form.id,
                            roleName:response.data.data.tAdnRole.roleName,
                            roleType:response.data.data.tAdnRole.permissionXResource,
                            moduleType:response.data.data.tAdnRole.subordinateModuleType,
                            detail:response.data.data.tAdnRole.detail
                        }
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error("获取失败");
                    console.log(error);       //请求失败返回的数据
                })
            },
            handleDelete(index, row) {
                this.form.id = row.id;
                this.visible.delVisible = true;
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let i=0;i<val.length;i++){
                    this.multipleSelection.push(val[i].id);
                }
            },
            delAll() {
                if(this.multipleSelection.length==0){
                    this.$message.warning("请先选择数据");
                    return;
                }
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var roleIds = this.multipleSelection.join(",");
                    this.$axios({
                        method:'get',
                        url: '/api/role/roleDeletes',
                        withCredentials:true,
                        params: {roleIds: roleIds}
                    }).then((response) =>{          //这里使用了ES6的语法
                        if(response.data.code == 1){
                            this.$message.success("删除成功");
                            this.initPages();
                        }else{
                            this.$message.warning(response.data.message);
                        }
                    }).catch((error) =>{
                        this.$message.error("删除失败");
                        console.log(error);       //请求失败返回的数据
                    }).finally(()=>{
                        this.multipleSelection = [];
                    })
                });
            },
            //保存创建
            saveCreate() {
                this.$axios({
                    method:'post',
                    url: '/api/role/create',
                    withCredentials:true,
                    data: this.$qs.stringify({
                        roleName:this.form.roleName,
                        detail:this.form.detail,
                        pxr:this.form.roleType,
                        subordinateModuleType: this.form.moduleType,
                    })
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.visible.createVisible = false;
                        this.$message.success(`创建成功`);
                        this.initPages();
                    }else{
                        this.visible.createVisible = false;
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.visible.createVisible = false;
                    this.$message.error(`创建失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.form = {};
                })
            },
            // 保存编辑
            saveEdit() {
                console.log(this.form.id);
                this.$axios({
                    method:'post',
                    url: '/api/role/edit',
                    withCredentials:true,
                    data: this.$qs.stringify({
                        roleId: this.form.id,
                        roleName: this.form.roleName,
                        subordinateModuleType: this.form.moduleType,
                        detail: this.form.detail,
                        pxr: this.form.roleType
                    })
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success(`修改成功`);
                        this.initPages();
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`修改失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.visible.editVisible = false;
                    this.form = {};
                })
            },
            // 确定删除
            deleteRow(){
                this.$axios({
                    method:'get',
                    url:'/api/role/roleDelete',
                    withCredentials:true,
                    type:'json',
                    params: {
                        roleId:this.form.id
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.visible.delVisible = false;
                        this.$message.success(`删除成功`);
                        this.initPages();
                    }else{
                        this.visible.delVisible = false;
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.visible.editVisible = false;
                    this.$message.error(`删除失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.form = {};
                })
            },
            saveRoleResources(){
                var tempList = this.$refs.resourceTree.getCheckedNodes();
                var resourceIdsArr = [];
                for(let i=0;i<tempList.length;i++){
                    resourceIdsArr.push(tempList[i].resource.id);
                }
                var resourceIds = resourceIdsArr.join(",");
                this.$axios({
                    method:'get',
                    url:'/api/role/authorized',
                    withCredentials:true,
                    type:'json',
                    params: {
                        roleId: this.form.id,
                        porArray: resourceIds
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success(`配置资源成功`);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`配置资源失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.visible.resourceVisible = false;
                    this.form = {};
                })
            },
            saveRolePermission(){
                var tempList = this.$refs.permissionTree.getCheckedNodes();
                var permissionIdsArr = [];
                for(let i=0;i<tempList.length;i++){
                    permissionIdsArr.push(tempList[i].permission.id);
                }
                var permissionIds = permissionIdsArr.join(",");
                this.$axios({
                    method:'get',
                    url:'/api/role/authorized',
                    withCredentials:true,
                    type:'json',
                    params: {
                        roleId: this.form.id,
                        porArray: permissionIds
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.$message.success(`配置权限成功`);
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`配置权限失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                    this.visible.permissionVisible = false;
                    this.form = {};
                })
            },
            //初始模块类型筛选select数据
            initModules(){
                this.$axios({
                    method:'get',
                    url:'/api/user/getModules',
                    withCredentials:true,
                    type:'json',
                }).then((response) =>{          //这里使用了ES6的语法
                    console.log(">>>module初始化")
                    console.log(response)
                    if(response.data.code == 1){
                        this.modules = response.data.data;
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`获取模块列表失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                })
            },
        }
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>
